import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=79b1e93e&scoped=true"
import script from "./PersonalData.vue?vue&type=script&lang=js"
export * from "./PersonalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b1e93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b1e93e')) {
      api.createRecord('79b1e93e', component.options)
    } else {
      api.reload('79b1e93e', component.options)
    }
    module.hot.accept("./PersonalData.vue?vue&type=template&id=79b1e93e&scoped=true", function () {
      api.rerender('79b1e93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/uc/PersonalData.vue"
export default component.exports